import React from 'react';
import { Box } from '@mui/material';
import UserActions from './UserActions';

export default function TopBar() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        mb: 2,
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <UserActions />
    </Box>
  );
}
